/* B2B 商品行（おすすめ・新着・ランキング・最近チェック・関連商品） */
// 商品行：新着・ランキングは並び替えたコレクションから取得、最近チェックは閲覧履歴から表示
(function () {
  var esc = function (t) { var d = document.createElement('div'); d.textContent = t || ''; return d.innerHTML; };
  function initArrows(row) {
    var list = row.querySelector('[data-b2b-row-items]');
    var prev = row.querySelector('.b2b-row__arrow--prev');
    var next = row.querySelector('.b2b-row__arrow--next');
    if (!list || !prev || !next) return;
    var update = function () {
      prev.hidden = list.scrollLeft <= 4;
      next.hidden = list.scrollLeft + list.clientWidth >= list.scrollWidth - 4;
    };
    var step = function (dir) { list.scrollBy({ left: dir * list.clientWidth * 0.8, behavior: 'smooth' }); };
    prev.onclick = function () { step(-1); };
    next.onclick = function () { step(1); };
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  document.querySelectorAll('.b2b-row').forEach(function (row) {
    var src = row.dataset.source;
    var limit = parseInt(row.dataset.limit, 10) || 10;
    var list = row.querySelector('[data-b2b-row-items]');
    if (src === 'newest' || src === 'best_selling' || src === 'related') {
      var url = row.dataset.url + (row.dataset.url.indexOf('?') > -1 ? '&' : '?') + 'section_id=b2b-product-row';
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('.b2b-row__item');
        list.innerHTML = '';
        for (var i = 0; i < items.length && i < limit; i++) list.appendChild(items[i]);
        if (!list.children.length) row.hidden = true;
        initArrows(row);
      }).catch(function () { row.hidden = true; });
    } else if (src === 'recent') {
      var data = [];
      try { data = JSON.parse(localStorage.getItem('b2b_recent') || '[]'); } catch (e) {}
      var skip = row.dataset.exclude;
      if (skip) data = data.filter(function (p) { return p.h !== skip; });
      if (!data.length) { if (window.Shopify && Shopify.designMode) row.hidden = false; return; }
      list.innerHTML = data.slice(0, limit).map(function (p) {
        return '<li class="b2b-row__item"><a class="b2b-mini" href="' + esc(p.u) + '" title="' + esc(p.t) + '">' +
          '<span class="b2b-mini__img">' + (p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy" width="150" height="150">' : '') + '</span>' +
          '<span class="b2b-mini__name">' + esc(p.t) + '</span></a></li>';
      }).join('');
      row.hidden = false;
      initArrows(row);
    } else {
      initArrows(row);
    }
  });
})();
